import './Stars.scss'

/**
 * Given a string or number value, return a string of the form x.5 or x
 * @param  {string|number} rating 
 * @return {string}
 */
const getRatingClass = (rating) => {
  if (!rating) {
    return null
  }
  const safeRating = parseFloat(rating)
  const roundedToPoint5 = (Math.round(safeRating * 2) / 2).toFixed(1)
  return roundedToPoint5.toString()
    .replace('.0', '')
    .replace('.', '-')
}

const Stars = ({
  className,
  rating,
  globalRating,
  onClick,
  clickable = onClick,
}) => (
  <div class={`mv-reviews-stars ${className}`}>
    <div class={`mv-stars mv-star-ratings mv-rating-${getRatingClass(globalRating)} mv-rating-user-${getRatingClass(rating)}`}>
      <svg class="star-ratings" data-name="Star Ratings" xmlns="http://www.w3.org/2000/svg" viewBox="-568 -176 76 11.4" >
        {clickable &&
          <path onClick={() => onClick(5)} data-name="Hover Area 5 Stars" class="star-hover-area" d="M-2,0,12,0,12,12,-2,12Z" transform="translate(-504 -176)" />
        }
        <path data-name="5 Stars" class="star rating-5" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-504 -176)" />
        <path data-name="4.5 Stars" class="star rating-4-5 rating-5" d="M6,0,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-504 -176)" />
        {clickable &&
          <path onClick={() => onClick(5)} data-name="Clickable 5 Stars" class="star-hover" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-504 -176)" />
        }
        {clickable &&
          <path onClick={() => onClick(4)} data-name="Hover Area 4 Stars" class="star-hover-area" d="M-2,0,14,0,14,12,-2,12Z" transform="translate(-520 -176)" />
        }
        <path data-name="4 Stars" class="star rating-4 rating-4-5 rating-5" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-520 -176)" />
        <path data-name="3.5 Stars" class="star rating-3-5 rating-4 rating-4-5 rating-5" d="M6,0,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-520 -176)" />
        {clickable &&
          <path onClick={() => onClick(4)} data-name="Clickable 4 Stars" class="star-hover" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-520 -176)" />
        }
        {clickable &&
          <path onClick={() => onClick(3)} data-name="Hover Area 3 Stars" class="star-hover-area" d="M-2,0,14,0,14,12,-2,12Z" transform="translate(-536 -176)" />
        }
        <path data-name="3 Stars" class="star rating-3 rating-3-5 rating-4 rating-4-5 rating-5" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-536 -176)" />
        <path data-name="2.5 Stars" data-star="2-5" class="star rating-2-5 rating-3 rating-3-5 rating-4 rating-4-5 rating-5" d="M6,0,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-536 -176)" />
        {clickable &&
          <path onClick={() => onClick(3)} data-name="Clickable 3 Stars" class="star-hover" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-536 -176)" />
        }
        {clickable &&
          <path onClick={() => onClick(2)} data-name="Hover Area 2 Stars" class="star-hover-area" d="M-2,0,14,0,14,12,-2,12Z" transform="translate(-552 -176)" />
        }
        <path data-name="2 Stars" class="star rating-2 rating-2-5 rating-3 rating-3-5 rating-4 rating-4-5 rating-5" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-552 -176)" />
        <path data-name="1.5 Stars" class="star rating-1-5 rating-2 rating-2-5 rating-3 rating-3-5 rating-4 rating-4-5 rating-5" d="M6,0,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-552 -176)" />
        {clickable &&
          <path onClick={() => onClick(2)} data-name="2 Stars" class="star-hover" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-552 -176)" />
        }
        {clickable &&
          <path onClick={() => onClick(1)} data-name="Hover Area 1 Star" class="star-hover-area" d="M0,0,14,0,14,12,0,12Z" transform="translate(-568 -176)" />
        }
        <path data-name="1 Star" class="star rating-1 rating-1-5 rating-2 rating-2-5 rating-3 rating-3-5 rating-4 rating-4-5 rating-5" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-568 -176)" />
        {clickable &&
          <path onClick={() => onClick(1)} data-name="Clickable 1 Star" class="star-hover star rating-1 rating-1-5 rating-2 rating-2-5 rating-3 rating-3-5 rating-4 rating-4-5 rating-5" d="M6,0,7.875,3.75,12,4.35,9,7.275,9.675,11.4,6,9.45,2.325,11.4,3,7.275,0,4.35l4.125-.6Z" transform="translate(-568 -176)" />
        }
      </svg>
    </div>
  </div>
)

Stars.defaultProps = {
  className: '',
  rating: 'na',
  globalRating: 'na',
  onClick: () => null,
}

export default Stars
